<div class="home-top clearfix">
	<div class="notification-container fRight">
		<!-- inject improve health component-->
		<app-wellbeing-score></app-wellbeing-score>
	</div> 
	<br>
</div>

	
  